import {hasAValue} from "./SharedFunctions";
import {checkAvailabilityValidityDataCall} from "../api/ApiCalls";

// Validate email format
export function validateEmail(email) {
    // Regular expression pattern for email validation
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
}

export async function validateEmailAndSubscription(email) {
    try {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (emailPattern.test(email)) {
            let response = await checkAvailabilityValidityDataCall("email", email);
            return !response.hasSubscription;
        } else {
            return false;
        }
    } catch (error) {
        // Handle the error here
        console.error('An error occurred during email validation:', error);
        return false;
    }
}

// Email domain typo suggestions map
const EMAIL_DOMAIN_SUGGESTIONS = {
    // Gmail typos
    'gmial.com': 'gmail.com',
    'gmai.com': 'gmail.com',
    'gmial.nl': 'gmail.com',
    'gmaill.com': 'gmail.com',
    'gmil.com': 'gmail.com',
    'gamil.com': 'gmail.com',
    'gnail.com': 'gmail.com',
    'gmaiil.com': 'gmail.com',

    // Hotmail typos
    'hotmial.com': 'hotmail.com',
    'hotmail.co': 'hotmail.com',
    'hotmil.com': 'hotmail.com',
    'hotmai.com': 'hotmail.com',
    'hotmail.con': 'hotmail.com',
    'hotamil.com': 'hotmail.com',
    'hotnail.com': 'hotmail.com',

    // Outlook typos
    'outlok.com': 'outlook.com',
    'outloo.com': 'outlook.com',
    'outlook.co': 'outlook.com',
    'outlookk.com': 'outlook.com',

    // Yahoo typos
    'yaho.com': 'yahoo.com',
    'yahooo.com': 'yahoo.com',
    'yahoo.co': 'yahoo.com',
    'yahho.com': 'yahoo.com',
    'yhaoo.com': 'yahoo.com',

    // Dutch providers
    'zigg.nl': 'ziggo.nl',
    'zigo.nl': 'ziggo.nl',

    // TLD typos
    'gmail.con': 'gmail.com',
    'gmail.cmo': 'gmail.com',
    'hotmail.cmo': 'hotmail.com',
    'yahoo.cmo': 'yahoo.com',
    'outlook.cmo': 'outlook.com',

    // Live.com typos
    'live.co': 'live.com',
    'liv.com': 'live.com',
    'livee.com': 'live.com',

    // iCloud typos
    'icloud.con': 'icloud.com',
    'icloud.nl': 'icloud.com',
    'iclod.com': 'icloud.com',
};

/**
 * Check if email has a typo in the domain and suggest correction
 * @param {string} email - Email address to check
 * @returns {object|null} - Returns {original: string, suggested: string, originalDomain: string, suggestedDomain: string} or null if no typo
 */
export function checkEmailTypo(email) {
    if (!hasAValue(email)) {
        return null;
    }

    const emailLower = email.toLowerCase().trim();
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // Only check valid email format
    if (!emailPattern.test(emailLower)) {
        return null;
    }

    // Extract domain (everything after @)
    const parts = emailLower.split('@');
    if (parts.length !== 2) {
        return null;
    }

    const username = parts[0];
    const domain = parts[1];

    // Check if domain is in typo map
    if (EMAIL_DOMAIN_SUGGESTIONS[domain]) {
        const suggestedDomain = EMAIL_DOMAIN_SUGGESTIONS[domain];
        return {
            original: emailLower,
            suggested: `${username}@${suggestedDomain}`,
            originalDomain: domain,
            suggestedDomain: suggestedDomain
        };
    }

    return null;
}

export async function validateStudentEmailAddressAndSubscription(email) {
    try {
        let emailValid = await validateEmailAndSubscription(email);
        if (emailValid) {
            let response = await checkAvailabilityValidityDataCall("student_email_address", email);
            return response.is_available;
        } else {
            return false;
        }
    } catch (error) {
        // Handle the error here
        console.error('An error occurred during email address validation:', error);
        return false;
    }
}

export function validateName(value) {
    const minLength = 3;
    return value.length >= minLength;
}


export function validatePassword(password) {
    // Password should have at least 8 characters
    const minLength = 3;
    return password.length >= minLength;
}

export function validatePasswordHard(password) {
    // Password should have at least 8 characters
    hasAValue(password)
    const minLength = 8;
    return  hasAValue(password) && password.length >= minLength;
}

export function validatePostalCode(postal_code) {
    const minLength = 6;
    const pattern = /^[0-9]{4}[A-Za-z]{2}$/;

    return (
        hasAValue(postal_code) &&
        postal_code.length === minLength &&
        !/\s/.test(postal_code) &&
        pattern.test(postal_code)
    );
}

export function validateHouseNumber(house_number) {
    const minLength = 0;
    return hasAValue(house_number) &&  house_number.length > minLength;
}


export function validateArray(array) {
    const minLength = 1; // Minimum length required for the array

    return Array.isArray(array) && array.length >= minLength;
}
